import { appliesToCaseGroup } from '../properties/index.js';
export const getPropertyFilterType = (propertyTypes, selection) => {
    if (selection == null) {
        return undefined;
    }
    return propertyTypes.find((type) => selection.propertyTypeId != null
        ? type.propertyTypeId === selection.propertyTypeId
        : type.ref === selection.referenceType &&
            type.handle === selection.handle &&
            appliesToCaseGroup(type, selection.scopeId));
};
//# sourceMappingURL=property-filter.js.map